<script setup>
import { onMounted, ref, reactive } from 'vue'
import * as Helper from './helper/setDefaultValues.js'
import apiProvider from './service/api-service.js'
import logService from './service/log-service.js'
import FindByZipComponent from './components/findByZip.vue'
import OfficeResultsComponent from './components/officeResults.vue'
import FindByLocationComponent from './components/findByLocation.vue'

const props = defineProps({
    faoJson: {
        type: String
    },
    faoScreen: {
        type : String
    }
})
const faoModel = ref(JSON.parse(props.faoJson))
    faoModel.value = Helper.setDefaultValues(faoModel.value)

const recent = reactive({
    officeURL: '',
    address: '',
    isRecentlyVisited: false,
    allQueryParams:'',
    filterQueryPrams : ''
})

onMounted(() => {
    if (window.$cookies.get("jh-header-nav-find-office-recent")) {
        if (JSON.parse(window.$cookies.get("jh-header-nav-find-office-recent")).type == "recent") {
            var recentOffice = JSON.parse(window.$cookies.get("jh-header-nav-find-office-recent"));
            recent.officeURL = recentOffice.officeURL;
            recent.address = recentOffice.address;
            recent.isRecentlyVisited = true;
        }
    }
    
    const queryParams = new URLSearchParams(window.location.search);
    let finalParams = {};

    queryParams.forEach((value, key) => {
        if (key.includes('utm')) {
            finalParams[key] = value;
        } else {
            finalParams[key] = value;
        }
    });

    recent.allQueryParams = Object.entries(finalParams)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

    recent.filterQueryPrams = Array.from(queryParams.keys()).filter(key =>!key.includes('utm')).map(
        (key) => `${key}=${queryParams.get(key)}`
    ).join('&');
})

const isLoading = ref(false)
const isResult = ref(false)
const showErrorMessage = ref('')
const searchString = ref('')
let response = ref(null)

async function callByZip(data) {
    await getJHNavOffices(data);
}

async function callByLocation(data) {
    await getJHNavOffices(data);
}

async function getJHNavOffices(searchStringOrObject) {
    isLoading.value = true;
    showErrorMessage.value = ''
    searchString.value = searchStringOrObject;
    response = await apiProvider.getJHNavOfficeSearch(searchStringOrObject);
    if (response != null && typeof(response) === "object") {
        if (response.Offices.length != 0) {
            isLoading.value = false;
            isResult.value = true;
        }
        else {
            isLoading.value = false;
            showErrorMessage.value = `${faoModel.value.noResultErrorFAO} ${searchStringOrObject}`;
        }
    }
    else {
        showErrorMessage.value = 'Sorry, error finding office locations!';
        isLoading.value = false;
    }
}

const getFAOGeoLocationError = (errorMessage) =>{
    showErrorMessage.value = errorMessage;
}

const jhNavFAOGoBack = (zipcode) => {
    response = null;
    showErrorMessage.value = '';
    isResult.value = false;
    searchString.value = zipcode;
}

const logAnEvent = (eventName) => {
    logService.eventLog(eventName);
}

const viewOfficesOnMap = (eventName, url) => {
    var queryParams= (recent.allQueryParams !=null && recent.allQueryParams != '') ? '&' + recent.allQueryParams:'';
    logAnEvent(eventName);
    try{
        window.location.href = `${faoModel.value.officeYextDomain}${url}${queryParams}`;
    } catch(error){
        window.location.href = `/officelocator/?search=&filterWallmart=false&filterOpenAllYear=false&filterSpanishSpeaking=false&filterRefundAdvance=false&filterTaxCourses=false&open=false${queryParams}`;
    };
}

</script>
<template>
    <div class="headerFAO-block" role="tooltip" @click="(e) => e.stopPropagation()">
        <div class="headerFAO-block-officeSearch" v-if="!isResult">
            <p class="headerFAO-block__title">{{ faoModel.titleForFAO }}</p>
            <FindByLocationComponent :faoModel="faoModel" @callByLocation="callByLocation($event)" @callByLocationError="getFAOGeoLocationError" :faoScreen="faoScreen"/>
            <p class="headerFAO-block__orText">or</p>

            <FindByZipComponent :faoModel="faoModel" @callByZip="callByZip($event)" @callByZipError="getFAOGeoLocationError" :searchString="searchString" :faoScreen="faoScreen"/>

            <div class="headerFAO-block__noResults" v-if="showErrorMessage">{{ showErrorMessage }}</div>
            <a :href="'/' + recent.DetailsUrl" class="headerFAO-block__recentOffice" 
                @click="logAnEvent('Recently visited office clicked')"
                v-if="recent.isRecentlyVisited">
                <div><span>Recently visited:</span><span>{{ recent.address }}</span></div>
            </a>
            <div class="headerFAO-block__loader" v-if="isLoading"></div>
            <div class="headerFAO-block__viewOfficesCntr">
                <a @click="viewOfficesOnMap('View offices on map button clicked','/office-locator/?search=&filterWallmart=false&filterOpenAllYear=false&filterSpanishSpeaking=false&filterRefundAdvance=false&filterTaxCourses=false&open=false')"
                    :id="'jh-view-offices-' + faoScreen" class="headerFAO-block__viewOfficesBtn">View offices on map</a>
            </div>
        </div>
        <OfficeResultsComponent :faoModelData="faoModel" :officesData="response" :searchStringOrObject="searchString" :queryParameters="recent.allQueryParams" :filterQueryPrams = "recent.filterQueryPrams"
            @jhNavFAOGoBack="jhNavFAOGoBack($event)" v-if="isResult" /> 
    </div>
</template>
<style>
@import './findAnOffice.css';
</style>
